export const reducer = (state, action ) => {

    if(action.type === "HOME_UPDATE"){
        return {...state, 
            name: action.payload.name, 
            photu: action.payload.photu,
            tdata: action.payload.tdata,};
    };

    if(action.type === "ABOUT_UPDATE"){
        return {...state, 
            name: action.payload.name, 
            photu: action.payload.photu,
            tdata: action.payload.tdata};
    };

    if(action.type === "GET_SERVICES"){
        return {...state, 
            services: action.payload,};
    };
 
    
}